import { getDonghoCountAPI } from "@/apis/apt-api"
import { getLeakUnitsAPI } from "@/apis/analysis-api"
import { create } from "zustand"
import { langStore } from "@/stores/lang-store"
import { formatMessage } from "@/utils/format-message"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { leakChartStore } from "./_components/leak/leak-chart-store"
import { analysisBundle } from "./analysis-const"

const isSameDong = (unitDong, selectedDong) => {
  if (selectedDong === "all") {
    return true
  }

  return Number(unitDong) === Number(selectedDong)
}

export const analysisStore = create((set, get) => ({
  originDongs: [],
  dongs: [],

  allLeakUnits: [],
  filteredLeakUnits: [],
  selectedDong: "all",
  donghoCountMap: {},
  dongBadgesMap: null,

  setSelectedDong: (selectedDong) => {
    const { allLeakUnits } = get()

    const filteredLeakUnits =
      selectedDong === "all"
        ? allLeakUnits
        : allLeakUnits.filter((unit) => isSameDong(unit.dong, selectedDong))

    set({
      selectedDong,
      filteredLeakUnits
    })
  },

  dongMapping: (dongs) => {
    const { lang } = langStore.getState()

    const dongMaps = [
      {
        id: "all",
        label: analysisBundle.all[lang]
      },
      ...dongs.map((d) => ({
        id: d,
        label: formatMessage(analysisBundle.dong[lang], {
          dong: d
        })
      }))
    ]

    set({
      dongs: dongMaps
    })
  },

  apiGetLeakUnits: async () => {
    const { sido, kapt_code } = aptSearchStore.getState().pickApt

    const leakUnits = await getLeakUnitsAPI({
      sido,
      kapt_code,
      dong: "all"
    })

    const { setLeakUnits } = leakChartStore.getState()

    leakUnits

    setLeakUnits(leakUnits)

    const updateDongBadgesMap = {}

    leakUnits.forEach((item) => {
      const dong = Number(item.dong)

      if (!updateDongBadgesMap[dong]) {
        updateDongBadgesMap[dong] = {
          dongBadges: {}
        }
      }

      updateDongBadgesMap[dong].dongBadges.leak =
        (updateDongBadgesMap[dong].dongBadges.leak || 0) + 1
    })

    set({
      allLeakUnits: leakUnits,
      filteredLeakUnits: leakUnits,
      dongBadgesMap: updateDongBadgesMap
    })

    return true
  },

  getFilteredLeakUnits: () => {
    const { allLeakUnits, selectedDong } = get()

    if (selectedDong === "all") {
      return allLeakUnits
    }

    return allLeakUnits.filter((unit) => isSameDong(unit.dong, selectedDong))
  },

  apiGetDonghoCount: async () => {
    const { sido, kapt_code } = aptSearchStore.getState().pickApt

    const donghoCountMap = await getDonghoCountAPI({
      sido,
      kapt_code
    })

    set({
      donghoCountMap,
      originDongs: Object.keys(donghoCountMap).map((n) => +n)
    })
  },

  reset: () => {
    set({
      originDongs: [],
      dongs: [],
      allLeakUnits: [],
      filteredLeakUnits: [],
      selectedDong: "all",
      donghoCountMap: {},
      dongBadgesMap: {}
    })

    leakChartStore.getState().reset()
  }
}))
